export default "__VITE_ASSET__GF9Slcbh__"